export const DEFAULT_CONTROLS_TAB = "dashboard";

/** Sidebar tabs that are navigable (disabled tabs are excluded). */
export const CONTROLS_TAB_IDS = [
  "dashboard",
  "controls",
  "calendar",
  "finding",
  "report",
  "all-controls",
];

export function isValidControlsTab(tab) {
  if (!tab) return false;
  return CONTROLS_TAB_IDS.includes(tab);
}

/**
 * Build a shareable Controls module URL.
 * @param {string} tab
 * @param {{ framework?: string, sub?: string }} opts
 */
export function controlsPath(tab = DEFAULT_CONTROLS_TAB, { framework, sub } = {}) {
  const safeTab = isValidControlsTab(tab) ? tab : DEFAULT_CONTROLS_TAB;
  const params = new URLSearchParams();
  if (framework) params.set("framework", framework);
  if (sub && sub !== "controls") params.set("sub", sub);
  const qs = params.toString();
  return `/controls/${safeTab}${qs ? `?${qs}` : ""}`;
}

/** Parse pathname + search into Controls navigation state. */
export function parseControlsLocation({ pathname, search }) {
  const parts = pathname.split("/").filter(Boolean);
  const tab = parts[1] || DEFAULT_CONTROLS_TAB;
  const params = new URLSearchParams(search || "");

  return {
    tab: isValidControlsTab(tab) ? tab : DEFAULT_CONTROLS_TAB,
    framework: params.get("framework") || null,
    sub: params.get("sub") || "controls",
  };
}
